import { useApiList } from "@/queries/base/useApiList";

/**
 * Fetches Repair Part Usages.
 * GET /repair_part_usage
 */
export function useRepairPartUsages(deps = [], params = {}) {
  const query = new URLSearchParams(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== "",
    ),
  ).toString();
  return useApiList(
    `/repair_part_usage${query ? `?${query}` : ""}`,
    [deps, params],
  );
}
